


import BaseDomainService from './baseDomainServices';
import { SuccessMessage } from '../../utils/Messages';


export default class FileConfigServices extends BaseDomainService {


   getAllModuleNameList = this.apiService.fileConfigServices.getAllModuleNameList;
   updateFileDeleteEligibiltyAfterDaysByModuleType = this.apiService.fileConfigServices.updateFileDeleteEligibiltyAfterDaysByModuleType;

    constructor() {
        super();
     
    }

    onGetAllModuleNameList  = (request) => {
        this.apiService.onAPICall("getAllModuleNameList", this.getAllModuleNameList, request, this.onAPIResponse, this.onUpdateState);
    }

    onUpdateFileDeleteEligibiltyAfterDaysByModuleType = (request) => {
        this.apiService.onAPICall("updateFileDeleteEligibiltyAfterDaysByModuleType", this.updateFileDeleteEligibiltyAfterDaysByModuleType, request, this.onAPIResponse, this.onUpdateState);
    }


    onAPIResponse = (key, isSuccess, responseData, getRequest) => {
        if (!isSuccess) {
            this.onUpdateState({ "setIsLoad": false, "loading": false });
            return;
        }
        switch (key) {
           
            case "getAllModuleNameList":
                
                let list = responseData;
                if (list) {
                   
                    this.onUpdateState({
                        setModuleList: list,
                        "setIsLoad": false,
                    });
                }
                break;

            case "updateFileDeleteEligibiltyAfterDaysByModuleType":
                if (responseData.hasError === true) {
                    this.apiService.serviceManager.swalServices.Success(responseData.errorMessage + " and " + responseData.errorType);
                } else {
                    this.apiService.serviceManager.swalServices.Success(SuccessMessage.Update_Success.replace("{0}", ""));
                    //this.onRedirectoList();
                }
                this.onUpdateState({ setIsLoad: false });
                break;

        
            default:
                // Handle default case here
                break;
        }
    }

}